import { makeAutoObservable } from 'mobx';
import { fetchCandidatesMetadata } from '../api/SlmService';
import notificationStore from './NotificationStore';

class StaticDataStore {
  tradeTypes = [];

  employmentTypes = [];

  yearsOfExperiences = [];

  militaryStatuses = [];

  notificationStore = {};

  payFrequencies = [];

  benefits = [];

  constructor(newNotificationStore) {
    this.notificationStore = newNotificationStore;
    makeAutoObservable(this);

    this.fetchStaticData();
  }

  fetchStaticData = async () => {
    try {
      const {
        tradeTypes, employmentTypes, yearsOfExperiences, payFrequencies, militaryStatuses, benefits
      } = await fetchCandidatesMetadata();
      this.tradeTypes = tradeTypes;
      this.employmentTypes = employmentTypes;
      this.yearsOfExperiences = yearsOfExperiences;
      this.militaryStatuses = militaryStatuses;
      this.payFrequencies = payFrequencies;
      this.benefits = benefits;
    } catch (error) {
      this.notificationStore.setError('Failed to fetch candidates static data, please reload the page');
    }
  };
}

export default new StaticDataStore(notificationStore);
